
const  contentTypeImage = (contentType:number) => {        

    switch (contentType) {
        case 0:
            return "/images/content-types/list_icon.svg"
        case 1:
            return "/images/content-types/page_icon.svg"
        case 2:
            return "/images/content-types/rss_icon.svg"
        case 3:
            return "/images/content-types/contact_icon.svg"
        case 4:
            return "/images/content-types/html_icon.svg"
        case 5:
            return "/images/content-types/image_icon.svg"
        case 6:
            return "/images/content-types/file_icon.svg"
        case 7:
            return "/images/content-types/video_icon.svg"
        case 8:
            return "/images/content-types/page_icon.svg"
        case 9:
            return "/images/content-types/audio_icon.svg"
        case 11:
            return "/images/content-types/combinedFeed_icon.svg"
    }
}

const contentTypeString = (contentType:number) => {        

    switch (contentType) {
        case 0:
            return "List"
        case 1:
            return "Page"
        case 2:
            return "Rss"
        case 3:
            return "Contact"
        case 4:
            return "Existing content"
        case 5:
            return "Image"
        case 6:
            return "Download"
        case 7:
            return "Video"
        case 8:
            return "Page"
        case 9:
            return "Audio"
       case 11:
            return "Combined Feed"
    }
}

export { contentTypeImage, contentTypeString}